<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XWk1KN/tc-custom/9781446361856.jpg?1705006396836" alt="This image is the cover for the book Maisie Parrish's Naughty Cakes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maisie Parrish's Naughty Cakes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>7 fabulous cake designs that are funny, unique and just a little bit naughty, brought to you by internationally acclaimed sugar artist Maisie Parrish - perfect gifts for grown-up parties and celebrations!</b></p><p>Maisie leads you step-by-step through all of the sugar modelling required to recreate her fabulous cake designs, which include a hunky fireman, a rather risque stripper and a ladies night at the pool!</p><p>Each cake design comes complete with a mini cake variation so you can make smaller cakes to suit your event. There's also a comprehensive guide to using sugarpaste, character modelling techniques and cake recipes.</p><p>The cake designs are funny with a saucy sense of humour, but not childish, and guaranteed to raise a smile rather than cause offence. They are great for grown-up recipients, a perfect centrepiece for birthdays, hen and stag parties, retirements and other fun occasions.</p><p>Maisie is a sugarcraft tutor for Wilton (US) and Squires Kitchen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maisie Parrish
      </h2>
      
      <p class="authorDescription body article"><P><B>Maisie Parrish</B> is a world-renowned sugarcraft teacher who specializes in creating fun sugar characters in her own unique style. She teaches workshops internationally and is also an instructor for cake giant Wilton in the US and demonstrator for Squires Kitchen and the British Sugarcraft Guild in the UK. She contributes to numerous magazines including <I>Cakes & Sugarcraft</I> and <I>Cake Craft & Decoration</I>, and is the author of bestselling cake decorating books. Maisie is based in Staffordshire. www.maisieparrish.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fc642e6c